<form class="co-form u-bg2" [formGroup]="form">
  <div class="c-wrapper--small">
    @if (!hideDatePart()) {
    <div class="co-form__dateWrapper u-text-center">
      <div class="co-form__date u-br-normal">
        @if (isCasual()) {
        <p class="co-form__dateText">選択した日時<span>電話カウンセリング / {{ selected().startTime|date:'M月d日 HH:mm' }}</span></p>
        } @else {
        <p class="co-form__dateText">選択した場所/日時<span>{{ selected().place }} / {{ selected().startTime|date:'M月d日 HH:mm' }}</span></p>
        }
        <a class="co-form__dateBtn u-br-normal" (click)="back()">日時選択に戻る</a>
        <p class="expiration-time"><img src="https://stjstyleryugakudev001.z11.web.core.windows.net/time.svg">予約枠確保中&nbsp;{{ expirationCountdown() }}</p>
      </div>
    </div>
    }
    @if (!isRequestMaterial()) {
      <h2 class="co-form__title">ご希望の条件を入力してください。</h2>
      @if (hasCity()) {
        <h3 class="co-form__name">留学・ワーホリを検討している都市（複数選択可）<app-label [control]="form.controls.countries"></app-label></h3>
      } @else {
        <h3 class="co-form__name">留学・ワーホリを検討している国（複数選択可）<app-label [control]="form.controls.countries"></app-label></h3>
      }
      <ul class="co-form__country p-pageSearch__drop --bgnone" id="countries">
        @for (country of countriesArray(); track country; let i = $index) {
        <li class="p-pageSearch__dropItem --4">
          <input type="checkbox" [id]="'country-'+i" name="checkbox01" [class.next]="next() === 'countries'" [checked]="form.getRawValue().countries.includes(country)" (change)="countryChange($event)" [value]="country"
                 [class.has-error]="hasError(form.controls.countries, 'required')">
          <label [for]="'country-'+i">{{ country }}</label>
        </li>
        }
      </ul>
      @if (hasError(form.controls.countries, 'required') && hasCity()) {
      <mat-error>留学・ワーホリを検討している都市を選択してください</mat-error>
      } @else if (hasError(form.controls.countries, 'required')) {
      <mat-error>留学・ワーホリを検討している国を選択してください</mat-error>
      }
    }
    <h2 class="co-form__title">お客様の情報を入力してください。</h2>
    <h3 class="co-form__name">お名前（ふりがな）<app-label [control]="form.controls.lastNameKana" [conditionControl]="form.controls.firstNameKana"></app-label></h3>
    <div class="flex">
      <input class="co-form__text" type="text" [class.next]="next() === 'lastNameKana'" formControlName="lastNameKana" placeholder="たなか" id="lastNameKana" pattern="[\u3040-\u309F\u30A0-\u30FF]+" [class.has-error]="form.controls.lastNameKana.touched && form.controls.lastNameKana.invalid" [class.ok]="form.controls.lastNameKana.valid" autocomplete="family-name">
      <input class="co-form__text" type="text" [class.next]="next() === 'firstNameKana'" formControlName="firstNameKana" placeholder="たろう" id="firstNameKana" pattern="[\u3040-\u309F\u30A0-\u30FF]+" [class.has-error]="form.controls.firstNameKana.touched && form.controls.firstNameKana.invalid" [class.ok]="form.controls.firstNameKana.valid" autocomplete="given-name">
    </div>
    @if (hasError(form.controls.lastNameKana, 'required') || hasError(form.controls.firstNameKana, 'required')) {
    <mat-error>お名前（ふりがな）を入力してください</mat-error>
    }
    @if (hasError(form.controls.lastNameKana, 'pattern') || hasError(form.controls.firstNameKana, 'pattern')) {
    <mat-error>【!】「ひらがな」または「カタカナ」で入力してください</mat-error>
    }
    <h3 class="co-form__name">電話番号（ハイフンなし）<app-label [control]="form.controls.phoneNumber"></app-label></h3>
    <div>
      <input class="co-form__text" type="tel" [class.next]="next() === 'phoneNumber'" formControlName="phoneNumber" placeholder="09012345678" id="phoneNumber" [class.has-error]="form.controls.phoneNumber.touched && form.controls.phoneNumber.invalid" [class.ok]="form.controls.phoneNumber.valid" autocomplete="tel" inputmode="tel" pattern="0\d{10}">
    </div>
    @if (hasError(form.controls.phoneNumber, 'required')) {
    <mat-error>電話番号を入力してください</mat-error>
    }
    @if (hasError(form.controls.phoneNumber, 'pattern')) {
    <mat-error>11桁の半角数字で入力してください</mat-error>
    }
    <h3 class="co-form__name">メールアドレス<app-label [control]="form.controls.email"></app-label></h3>
    <div>
      <input class="co-form__text" type="email" [class.next]="next() === 'email'" formControlName="email" placeholder="example@mail.com" id="email" autocomplete="email" inputmode="url" [class.has-error]="form.controls.email.touched && form.controls.email.invalid" [class.ok]="form.controls.email.valid" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$">
    </div>
    @if (hasError(form.controls.email, 'required')) {
    <mat-error>メールアドレスを入力してください</mat-error>
    }
    @if (hasError(form.controls.email, 'pattern')) {
    <mat-error>正しいメールアドレスを入力してください</mat-error>
    }
    <div class="u-text-center">
      <div class="co-form__privacy">
        <input type="checkbox" id="agree" name="checkbox01" [class.next]="next() === 'agree'" formControlName="agree" [class.has-error]="form.controls.agree.touched && form.controls.agree.invalid"><label for="agree"></label><span><a href="https://ryugaku.yume-kana.com/policy/" target="_blank" rel="noopener noreferrer">利用規約・プライバシーポリシー</a>に同意する</span>
      </div>
      @if (hasError(form.controls.agree, 'required')) {
      <mat-error>利用規約・プライバシーポリシーへの同意は必須です</mat-error>
      }

      <div class="submit-button-wrapper" (click)="submit($event)">
        @if (topText()) {
        <div class="attention-boss" [innerHTML]="topText()"></div>
        }
        @if (!hasNextStep()) {
          @if (!isCasual()) {
            <div class="attention-box">今すぐご予約いただくと<br />最大{{ discount() }}万円割引が適用されます！</div>
          }
          <button class="co-form__btn u-br-normal c-btn c-btn--ac1" type="button" name="submitConfirm" value="{{ counselingText() }}カウンセリングを予約する" data-cv-btn [disabled]="sending()">
            {{ counselingText() }}カウンセリングを予約する
          </button>
        } @else if (isRequestMaterial()) {
          <button class="co-form__btn u-br-normal c-btn c-btn--ac1" type="button" name="submitConfirm" value="{{ counselingText() }}カウンセリングを予約する" data-cv-btn [disabled]="sending()">
            @if (cvButtonText()) {
              {{ cvButtonText() }}
            } @else {
              資料請求を見る
            }
          </button>
        } @else {
        <button class="co-form__btn u-br-normal c-btn c-btn--ac1" type="button" name="submitConfirm" value="{{ counselingText() }}カウンセリングを予約する" data-cv-btn [disabled]="sending()">
          日時選択に進む
        </button>
        }
      </div>
      <div class="notice">※取得した個人情報は許可なく使用することはありません。</div>
    </div>
    @if (!hideDatePart()) {
    <div class="co-callender__backwrapper">
      <a class="co-callender__back u-text-bold" (click)="back()">日時選択に戻る</a>
    </div>
    }
  </div>
</form>
@if (showPercentage()) {
  <div class="bar">
    <mat-progress-bar mode="determinate" [value]="percentage()"></mat-progress-bar>
    <div>残り<span>{{ remain() }}</span>ステップ</div>
  </div>
}
